import React from 'react';
import {IconButton, ListItem, ListItemText} from "@mui/material";
import {makeStyles} from "@mui/styles";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import clsx from "clsx";
import {Clear} from "@mui/icons-material";
import {format, parse, isSameMonth, isSameYear} from "date-fns";
import {useDispatch} from "react-redux";
import {
    setComplimentaryActivities,
    setDealerActivities,
    setExtraActivities
} from "../../../redux/actions/transactionActions";
import {shouldShowTime} from "../../../utils/utils";

const useStyles = makeStyles((theme) => ({
    section: {
        margin: theme.spacing(1, 0),
    },
    activityTime: {
        color: theme.palette.lightGray.text,
    },
    itineraryBtn: {
        marginLeft: theme.spacing(3),
        borderColor: '#f2f2f2',
        color: '#4c4c4c',
    },
}));

const ItineraryActivityDateFH = ({activities, date, removable}) => {
    const classes = useStyles();
    const tripActivity = date.includes('/');

    const dispatch = useDispatch();

    const getTripDate = (date) => {
        const dates = date.split('/');
        const startDate = parse(dates[0], 'yyyy-MM-dd', new Date());
        const endDate = parse(dates[1], 'yyyy-MM-dd', new Date());

        let formattedStringDate = `${format(startDate, 'LLL d yyyy')} - `;

        if (isSameMonth(startDate, endDate))
            formattedStringDate += `${format(endDate, 'd')}`;
        else
            formattedStringDate += format(endDate, 'LLL d yyyy');

        if (isSameYear(startDate, endDate))
            formattedStringDate = formattedStringDate.replace(format(startDate, 'yyyy'), '');

        return formattedStringDate;
    };

    const formattedDate = tripActivity ? getTripDate(date) : format(parse(date, 'yyyy-MM-dd', new Date()), 'LLL d');

    const handleRemoveActivity = (activity) => {
        switch (activity.type) {
            case 'extra':
                return dispatch(setDealerActivities(activity.company,activity.id, activity.availabilityId,null,false));
            default:
                return;
        }
    };


    return (
        <>
            <ListItem alignItems={"flex-start"}
                      style={{justifyContent: 'center', margin: 0, padding: '0 2px 0px'}}>
                <ListItemText primary={formattedDate} className="itineraryDate"/>
            </ListItem>
            {activities.map(activity => (
                <ListItem key={activity.id} className={classes.section}>
                    {activity.type !== 'trip' ? (<Grid container alignItems="center">
                        {shouldShowTime(activity.date) && (
                            <Grid item xs={4}>
                                <Typography gutterBottom variant="h5" align="left" className={classes.activityTime}>
                                    {format(activity.date, 'h:mm a')}
                                </Typography>
                            </Grid>
                        )}
                        <Grid item xs={shouldShowTime(activity.date) ? (6) : 10}>
                            <Typography gutterBottom variant="h5" align="left">
                                {activity.name}
                            </Typography>
                        </Grid>
                        {removable && <Grid item xs={2}>
                            <IconButton className={clsx({'itineraryBtn': true, [classes.itineraryBtn]: true})}
                                        aria-label="delete" size="small"
                                        onClick={() => handleRemoveActivity(activity)}>
                                <Clear fontSize="inherit"/>
                            </IconButton>
                        </Grid>}
                    </Grid>) : (<Grid container alignItems="center">
                        <Grid item xs={12}>
                            <Typography gutterBottom variant="h5" align="left">
                                {activity.name}
                            </Typography>
                        </Grid>
                    </Grid>)}
                </ListItem>
            ))}
        </>
    );
};

export default ItineraryActivityDateFH;
